
<!-- loading页面 -->
<template>
    <transition name="fade">
        <div v-if="config.visible" id="loading-warp">
            <div class="shade"></div>
            <div class="content">
                <img :src="logSrc" alt="">
            </div>
        </div>
    </transition>
</template>
<script lang="ts">
import loading from './loading';
export default loading;
</script>
<style scoped lang="scss">
#loading-warp{
    position: relative;
    z-index: 1000;
    .shade {
        // v1
        // background: rgba(0, 0, 0, 0.7);
        // v2
        background: rgba(0, 0, 0, .4);
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 10;
    }
    // v1
    // .content{
    //     position: fixed;
    //     height: 19.2vw;
    //     width: 19.2vw;
    //     // background: rgba(36, 36, 40, 0.75);
    //     border-radius: 3.2vw;
    //     z-index: 20;
    //     top: 0;
    //     left: 0;
    //     right: 0;
    //     bottom: 0;
    //     margin: auto;
    //     img{
    //         display: block;
    //         height: 19.2vw;
    //         width: 19.2vw;
    //     }
    // }
    // v2
    .content{
        position: fixed;
        height: 20vw;
        width: 20vw;
        background: rgba(0, 0, 0, 0.4);
        border-radius: 3.2vw;
        z-index: 20;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        padding: 3.0666vw;
        img{
            display: block;
            height: 100%;
            width: 100%;
        }
    }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>
